import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './AffiliateProgram.module.css';

export default function AffiliateProgram() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    website: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormData({
        name: '',
        email: '',
        company: '',
        website: '',
        message: '',
      });
    }, 1500);
  };

  return (
    <div className={styles.container}>
      <div className={styles.heroSection}>
        <h1 className={styles.title}>MyPeopleDatabase Affiliate Program</h1>
        <p className={styles.subtitle}>
          Partner with us and earn generous commissions while helping businesses transform their
          people management
        </p>
      </div>

      {/* Founders Affiliate Promotion */}
      <div className={styles.foundersPromotion}>
        <div className={styles.foundersContent}>
          <div className={styles.foundersHeader}>
            <span className={styles.foundersLabel}>🚀 LIMITED TIME OFFER</span>
            <h2 className={styles.foundersTitle}>Founders Affiliate Program</h2>
          </div>
          <div className={styles.foundersDetails}>
            <div className={styles.foundersCommission}>
              <span className={styles.commissionPercent}>30%</span>
              <span className={styles.commissionText}>Commission for ALL of 2026</span>
            </div>
            <p className={styles.foundersDescription}>
              Join as a Founders Affiliate and earn our highest commission rate of 30% on ALL
              referrals throughout 2026. This exclusive rate applies to both new subscriptions AND
              renewals for the entire year.
            </p>
            <div className={styles.foundersFeatures}>
              <div className={styles.foundersFeature}>
                <span className={styles.featureIcon}>✨</span>
                <span>30% on new subscriptions</span>
              </div>
              <div className={styles.foundersFeature}>
                <span className={styles.featureIcon}>🔄</span>
                <span>30% on renewals (usually 10%)</span>
              </div>
              <div className={styles.foundersFeature}>
                <span className={styles.featureIcon}>📅</span>
                <span>Valid for all of 2026</span>
              </div>
              <div className={styles.foundersFeature}>
                <span className={styles.featureIcon}>🎯</span>
                <span>Priority support & resources</span>
              </div>
            </div>
            <div className={styles.foundersAction}>
              <Link to="/signup" state={{ fromAffiliate: true }} className={styles.foundersButton}>
                Become a Founders Affiliate
              </Link>
              <Link to="/affiliate-pitch" className={styles.pitchButton}>
                📝 Get Promotion Templates
              </Link>
              <span className={styles.foundersUrgency}>Limited spots available</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.contentSection}>
        <div className={styles.benefitsSection}>
          <h2>Why Join Our Affiliate Program?</h2>

          <div className={styles.benefitCards}>
            <div className={styles.benefitCard}>
              <div className={styles.benefitIcon}>💰</div>
              <h3>Competitive Commissions</h3>
              <p>
                Earn 30% commission on each successful referral for the first year of their
                subscription
              </p>
            </div>

            <div className={styles.benefitCard}>
              <div className={styles.benefitIcon}>🚀</div>
              <h3>Easy Promotion</h3>
              <p>
                Access to marketing materials, banners, and product information to help you promote
                effectively
              </p>
            </div>

            <div className={styles.benefitCard}>
              <div className={styles.benefitIcon}>🔄</div>
              <h3>Recurring Revenue</h3>
              <p>
                Earn 30% commission on renewals during 2026, and 10% on renewals after the first
                year
              </p>
            </div>

            <div className={styles.benefitCard}>
              <div className={styles.benefitIcon}>🛠️</div>
              <h3>Dedicated Support</h3>
              <p>Get personalized support from our affiliate team to maximize your success</p>
            </div>
          </div>
        </div>

        <div className={styles.howItWorks}>
          <h2>How It Works</h2>

          <ol className={styles.stepsList}>
            <li>
              <span className={styles.stepNumber}>1</span>
              <div className={styles.stepContent}>
                <h3>Apply</h3>
                <p>
                  Fill out the application form below to express your interest in becoming an
                  affiliate
                </p>
              </div>
            </li>

            <li>
              <span className={styles.stepNumber}>2</span>
              <div className={styles.stepContent}>
                <h3>Get Approved</h3>
                <p>Our team will review your application and reach out within 2 business days</p>
              </div>
            </li>

            <li>
              <span className={styles.stepNumber}>3</span>
              <div className={styles.stepContent}>
                <h3>Promote</h3>
                <p>
                  Use your unique affiliate link and marketing materials to promote MyPeopleDatabase
                </p>
              </div>
            </li>

            <li>
              <span className={styles.stepNumber}>4</span>
              <div className={styles.stepContent}>
                <h3>Earn</h3>
                <p>Get paid monthly commissions on all successful referrals and renewals</p>
              </div>
            </li>
          </ol>
        </div>

        <div className={styles.applicationSection} id="apply">
          <h2>Apply to Become an Affiliate</h2>

          <div className={styles.affiliateAccessOptions}>
            <div className={styles.accessOption}>
              <h3>Already an affiliate?</h3>
              <p>Login to access your dashboard, view statistics, and get your affiliate links.</p>
              <Link to="/login" className={styles.actionButton}>
                Login to Dashboard
              </Link>
            </div>

            <div className={styles.accessOption}>
              <h3>New to our program?</h3>
              <p>Create an account to apply and get started with our affiliate program.</p>
              <Link to="/signup" state={{ fromAffiliate: true }} className={styles.actionButton}>
                Create Account
              </Link>
            </div>
          </div>

          {/*<div className={styles.divider}>
            <span>OR</span>
          </div>
          
          {isSubmitted ? (
            <div className={styles.successMessage}>
              <h3>Thank you for your interest!</h3>
              <p>We've received your application and will review it shortly. Our affiliate team will contact you within 2 business days.</p>
            </div>
          ) : (
            <form className={styles.applicationForm} onSubmit={handleSubmit}>
              <p className={styles.formInfo}>Submit the form below to express your interest without creating an account. We'll reach out with next steps.</p>
              
              <div className={styles.formGroup}>
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="company">Company Name</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="website">Website/Blog</label>
                <input
                  type="url"
                  id="website"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  placeholder="https://"
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="message">How do you plan to promote MyPeopleDatabase? *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  required
                ></textarea>
              </div>
              
              <button
                type="submit"
                className={styles.submitButton}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Application'}
              </button>
            </form>
          )}*/}
        </div>

        <div className={styles.faqSection}>
          <h2>Frequently Asked Questions</h2>

          <div className={styles.faqItem}>
            <h3>Who can join the affiliate program?</h3>
            <p>
              Our affiliate program is open to consultants, bloggers, content creators, and
              businesses that have an audience that could benefit from our people management
              software.
            </p>
          </div>

          <div className={styles.faqItem}>
            <h3>When do I get paid?</h3>
            <p>
              Commissions are calculated monthly and paid out the following month, provided you've
              reached the minimum payout threshold of $100.
            </p>
          </div>

          <div className={styles.faqItem}>
            <h3>How long do cookies last?</h3>
            <p>
              Our affiliate tracking cookies have a 60-day attribution window, meaning you'll
              receive credit for any purchase made within 60 days of a user clicking your affiliate
              link.
            </p>
          </div>

          <div className={styles.faqItem}>
            <h3>Can I promote to my existing customers?</h3>
            <p>
              Yes, as long as they aren't already MyPeopleDatabase customers. Our system tracks new
              versus existing users to ensure fair attribution.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
